import { IPaymentMethodLookupWithRequisiteType } from '../../Requisites/core/response.types'

/**
 * Реквизит кошелька (вид wallet) адресуется одним телефоном: карта и банк ему не нужны.
 * Истина, только если выбран хотя бы один метод и каждый из них — кошелёк.
 */
export const isWalletOnly = (
  paymentMethods: unknown,
  lookup: IPaymentMethodLookupWithRequisiteType[]
): boolean => {
  const selected = (Array.isArray(paymentMethods) ? paymentMethods : [])
    .map((pm) => String(pm ?? '').trim())
    .filter(Boolean)

  if (selected.length === 0) return false

  return selected.every((pmType) => {
    const kinds = lookup.find((x) => String(x.type).trim() === pmType)?.requisiteKinds ?? []
    return kinds.length === 1 && kinds[0] === 'wallet'
  })
}
